import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { disableGoogleAnalytics, loadGoogleAnalytics, useAnalyticsConsent } from '../lib/analytics';
import { useAuth } from './useAuth';
import { useConfig } from './useConfig';

// GA лише для покупців, які погодились: ніколи в адмінці й ніколи для адміна,
// інакше власні заходи власника спотворюють цифри на дашборді.
export function useGoogleAnalytics(): void {
  const { data: config } = useConfig();
  const { data: user, isLoading: authLoading } = useAuth();
  const consent = useAnalyticsConsent();
  const { pathname } = useLocation();
  const measurementId = config?.gaMeasurementId ?? '';
  const allowed =
    consent === 'granted' &&
    measurementId !== '' &&
    !authLoading &&
    user?.role !== 'admin' &&
    !pathname.startsWith('/admin');

  useEffect(() => {
    if (!measurementId) return;
    if (allowed) loadGoogleAnalytics(measurementId);
    else disableGoogleAnalytics(measurementId);
  }, [allowed, measurementId]);
}
